import './index.scss';
import { useContext } from 'react';
import { Search } from 'src/assets/icon';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import { Header } from 'src/component/Layout';
import { UsersCard } from 'src/component/Home/UsersCard';
import { TextInput } from 'src/style';
import { HomeScreenProps } from '../types';
import { getClassList, getStudentsList, getTeachersList } from 'src/utils/helpers';

export const AdminHome = ({ user }: HomeScreenProps) => {
    const { info } = useContext(AppInfoContext);
    const teachers = getTeachersList(info);
    const students = getStudentsList(info);
    const classes = getClassList(info);

    return (
        <div className='admin-home'>
            <Header user={user}>
                <TextInput
                    width='44'
                    topPadding='1.2'
                    leftPadding='2.5'
                    rightPadding='2.5'
                    bottomPadding='1.2'
                    className='search-container'
                >
                    <input type="text" placeholder='search...' />
                    <Search />
                </TextInput>
            </Header>
            <div className="list-container">
                <UsersCard title='Teachers' list={teachers} />
                <UsersCard title='Students' list={students} />
                <UsersCard title='Classes' list={classes} />
            </div>
        </div>
    )
}
